import { calculation, numConvert, sum } from "@/method";
import moment from 'moment';

export default function compute(data, date) {
    const month = moment(date).format('M');
    const totalName = ['grand_covers', 'grand_rev', 'grand_room', 'grand_other'];
    const leftName = ['wedding', 'social', 'group'];

    // grandtotal
    totalName.forEach(name => {
        data.forEach((item, i) => {
            if (![38, 41].includes(i)) {
                data[i][name] = leftName.reduce((a, b) => {
                    a += numConvert(item[`${b}_${name.split('_')[1]}`]);
                    return a;
                }, 0).toFixed(2);
            }
        });
    });

    // 计算收益
    [...leftName, 'grand'].forEach(name => {
        data.forEach((item, i) => {
            if (![38, 41].includes(i)) {
                data[i][`${name}_ac`] = calculation(data[i][`${name}_rev`], data[i][`${name}_covers`]);
                data[i][`${name}_total`] = sum(
                    [
                        data[i][`${name}_rev`],
                        data[i][`${name}_room`],
                        data[i][`${name}_other`],
                    ]
                );
            }
        });
    });


    // YTD 累加到当前月份之前  Year End
    [...leftName, 'grand'].forEach(left => {
        ['_covers', '_ac', '_rev', '_room', '_other', '_total'].forEach(right => {
            data[36][left + right] = data.reduce((a, b, i) => {
                if (i < 36 && Math.ceil((i + 1) / 3) < month && (i % 3 == 0)) {
                    a += numConvert(b[left + right]);
                }
                return a
            }, 0).toFixed(2);

            data[37][left + right] = data.reduce((a, b, i) => {
                if (i < 36 && Math.ceil((i + 1) / 3) < month && (i % 3 == 1)) {
                    a += numConvert(b[left + right]);
                }
                return a
            }, 0).toFixed(2);

            data[39][left + right] = data.reduce((a, b, i) => {
                if (i < 36 && (i % 3 == 0)) {
                    a += numConvert(b[left + right]);
                }
                return a
            }, 0).toFixed(2);
            data[40][left + right] = data.reduce((a, b, i) => {
                if (i < 36 && (i % 3 == 1)) {
                    a += numConvert(b[left + right]);
                }
                return a
            }, 0).toFixed(2);
        });
    });

    // 收益占比
    [...leftName, 'grand'].forEach(name => {
        data.forEach((item, i) => {
            // 计算YTD Year-End人均消费
            if (i >= 36) {
                data[i][name + '_ac'] = calculation(data[i][`${name}_rev`], data[i][`${name}_covers`], 2);
            }
            if (![38, 41].includes(i) && name != 'grand') {
                data[i][`${name}_proportion`] = calculation(data[i][`${name}_total`], data[i][`grand_total`], 4);
            }

        });
    });




    // Variance%
    [...leftName, 'grand'].forEach(left => {
        ['_covers', '_ac', '_rev', '_room', '_other', '_total'].forEach(right => {
            data[41][left + right] = calculation(
                data[40][left + right] - data[39][left + right],
                data[39][left + right],
                4
            );

            data[38][left + right] = calculation(
                data[37][left + right] - data[36][left + right],
                data[36][left + right],
                4
            );
        });
    });

    return data;
} 


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-1/6.1.2/compute.js